/*
I want tot build a collapsable card component in React with TypeScript. The card should have a title and content area. When the title is clicked, the content area should toggle between being visible and hidden. The component should accept props for the title text and the content to be displayed inside the card. Additionally, I want to add some basic styling to make it visually appealing.
that has a title and content area. When the title is clicked, the content area should toggle between being visible and hidden. The component should accept props for the title text and the content to be displayed inside the card. Additionally, I want to add some basic styling to make it visually appealing.
*/

import React, { useState } from 'react';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa6';
import { ChevronDown, ChevronUp, Info, Star, Shield } from 'lucide-react';

interface CollapsableCardProps {
  title: string;
  content: React.ReactNode;
}
const CollapsableCard: React.FC<CollapsableCardProps> = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);
    const toggleCard = () => {
    setIsOpen(!isOpen);
    };
    return (
    <div className={`${ isOpen ? `rounded-lg bg-[#143772] shadow-md w-full mb-4`: `rounded-full bg-[#143772] shadow-md w-full mb-4` }`}>
        <div className="text-white p-4 cursor-pointer flex justify-between items-center" onClick={toggleCard}>
        <h2 className="text-[20px] font-[600] font-semibold">{title}</h2>
        <span className="bg-[#274B89] rounded-full p-2">{isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}</span>
        </div>
        {isOpen && (
        <div className="p-4 text-white">
            {content}
        </div>
        )}
    </div>
    );
}   ;


export default CollapsableCard;
